(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockArbeitgeberBeruf', {
            require: {
                form: '^form'
            },
            bindings: {
                name: '@name',
                partner: '<ababPartner',
                comparePartner: '<ababComparePartner',
                disabled: '<ababDisabled',
                options: '<ababOptions'
            },
            templateUrl: 'bloecke/sonstiges/blockArbeitgeberBeruf.html',
            controller: BlockArbeitgeberBerufController,
            controllerAs: 'blockArbeitgeberBerufVm'
        })
        .service('BlockArbeitgeberBerufService', BlockArbeitgeberBerufService);

    BlockArbeitgeberBerufController.$inject = [
        'lodash',
        'AppConfig',
        'AngebotModel',
        'BasisAngebotService',
        'MiscUtilsService',
        'SchluesselWerteUtilsService',
        'BlockArbeitgeberBerufService'
    ];
    function BlockArbeitgeberBerufController(_, AppConfig, AngebotModel, BasisAngebotService, MiscUtilsService, SchluesselWerteUtilsService, BlockArbeitgeberBerufService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.isArbeitgeberBerufErlaubt = isArbeitgeberBerufErlaubt;
        vm.onArbeitsverhaeltnisAnpassen = onArbeitsverhaeltnisAnpassen;
        vm.isLinkArbeitsverhaeltnisAnpassenErlaubt = isLinkArbeitsverhaeltnisAnpassenErlaubt;

        vm.onArbeitsverhaeltnisChanged = onArbeitsverhaeltnisChanged;
        vm.onTaetigkeitsschluesselChanged = onTaetigkeitsschluesselChanged;
        vm.onBevorzugterArbeitgeberChanged = onBevorzugterArbeitgeberChanged;
        vm.onBevorzugterBerufszweigChanged = onBevorzugterBerufszweigChanged;
        vm.onIngenieurChanged = onIngenieurChanged;
        vm.onBlaulichtVorhandenChanged = onBlaulichtVorhandenChanged;

        vm.isBevorzugterArbeitgeberErlaubt = isBevorzugterArbeitgeberErlaubt;
        vm.isAngestellterBevorzugteArbeitgeberErlaubt = isAngestellterBevorzugteArbeitgeberErlaubt;
        vm.getAngestellterBevorzugteArbeitgeber = getAngestellterBevorzugteArbeitgeber;

        vm.isBevorzugterBerufszweigErlaubt = isBevorzugterBerufszweigErlaubt;
        vm.isSelbststaendigerBevorzugteBerufszweigeErlaubt = isSelbststaendigerBevorzugteBerufszweigeErlaubt;
        vm.getSelbststaendigerBevorzugteBerufszweige = getSelbststaendigerBevorzugteBerufszweige;
        vm.isIngenieurErlaubt = isIngenieurErlaubt;
        vm.isBlaulichtErlaubt = isBlaulichtErlaubt;

        function activate() {
            vm.sw = {};
            vm.options = vm.options || {};
            vm.angebotModel = AngebotModel.get();
            vm.isAnonym = MiscUtilsService.isEmpty(_.get(vm.partner, 'partnernummer.id'));
            vm.model = _.get(vm.angebotModel.formData, vm.name);

            vm.labelArbeitsverhaeltnis = vm.options.labelArbeitsverhaeltnis || 'Sind Sie Rentner oder Pensionär? Dann geben Sie bitte Ihr letztes Beschäftigungsverhältnis an.';
            vm.labelTaetigkeitsschluessel = vm.options.labelTaetigkeitsschluessel || 'Ich bin Beamter';
            vm.labelBevorzugterArbeitgeber = vm.options.labelBevorzugterArbeitgeber || 'Sind Sie bei einem dieser Arbeitgeber angestellt?';
            vm.labelBevorzugterBerufszweig = vm.options.labelBevorzugterBerufszweig || 'Sind Sie in einem dieser Berufsfelder selbstständig?';
            vm.labelIngenieur = vm.options.labelIngenieur || 'Ich bin Ingenieur';
            vm.labelBlaulicht = vm.options.labelBlaulicht || 'Ich bin ehrenamtlich tätig bei einer Blaulichtorganisation';

            if (!vm.model) {
                _.set(vm.angebotModel.formData, vm.name, {});
                vm.model = _.get(vm.angebotModel.formData, vm.name);
            }

            if (vm.angebotModel.wurdeGeladen) {
                _.set(vm.model, 'blaulichtVorhanden', MiscUtilsService.isNotEmpty(_.get(vm.partner, 'blaulicht.wert')));
            } else {
                _.set(vm.model, 'blaulichtVorhanden', MiscUtilsService.isNotEmpty(_.get(vm.partner, 'blaulicht.wert')) ? true : !!_.get(vm.model, 'blaulichtVorhanden'));
            }

            if (AppConfig.ANGEBOT.blaulichtVorhanden) {
                SchluesselWerteUtilsService.fetch('blaulicht').then(function (blaulicht) {
                    vm.sw.blaulicht = blaulicht;
                }).catch(function () {
                });
            }

            MiscUtilsService.setDefaultValueIfEmpty(vm.model, 'arbeitsverhaeltnis', null);

            vm.isPrivatPerson = BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot, vm.model);

            vm.CONSTANTS = {
                listen: {
                    taetigkeitsschluessel: BasisAngebotService.getConstant('taetigkeitsschluessel'),
                    arbeitgeber: SchluesselWerteUtilsService.getSchluesselwert('arbeitgeber')
                }
            };

            if (!vm.isAnonym && vm.disabled) {
                if (
                    _.get(vm.partner, 'arbeitgeber.wert') !== _.get(vm.comparePartner, 'arbeitgeber.wert') ||
                    _.get(vm.partner, 'beruf.wert') !== _.get(vm.comparePartner, 'beruf.wert') ||
                    MiscUtilsService.isEmpty(_.get(vm.comparePartner, 'arbeitgeber')) ||
                    MiscUtilsService.isEmpty(_.get(vm.comparePartner, 'beruf'))
                ) {
                    _.set(vm.model, 'arbeitsverhaeltnisAnpassen', true);
                }
            }

            setGuiFlags();

            if (vm.disabled) {
                getTaetigkeitsschluessel();
            } else {
                handleArbeitgeberBeruf();
            }
        }

        function onInit() {
            vm.options = vm.options || {};

            activate();
        }

        function onChanges() {
            activate();
        }

        function setGuiFlags() {
            if (
                vm.isAnonym ||
                _.get(vm.model, 'arbeitsverhaeltnisAnpassen') === true
            ) {

                _.merge(vm.model, BlockArbeitgeberBerufService.getGuiFlags(vm.partner));
            }
        }
        function getTaetigkeitsschluessel() {
            var arbeitgeberCode = SchluesselWerteUtilsService.get(_.get(vm.partner, 'arbeitgeber'), 'wert'),
                berufCode = SchluesselWerteUtilsService.get(_.get(vm.partner, 'beruf'), 'wert');

            if (MiscUtilsService.isAtLeastOneEmpty(arbeitgeberCode, berufCode) || arbeitgeberCode !== BasisAngebotService.getConstant('arbeitgeber.oeffentlicherDienst').wert) {
                _.set(vm.partner, 'taetigkeitsschluessel', _.find(BasisAngebotService.getConstant('taetigkeitsschluessel'), ['wert', '0']));
                return ;
            }

            BasisAngebotService.getTaetigkeitsschluessel(arbeitgeberCode, berufCode).then(function (taetigkeitsschluessel) {
                if (taetigkeitsschluessel.length > 1) {
                    vm.hasTaetigkeitsschluessel = true;
                } else if (taetigkeitsschluessel.length === 1) {
                    vm.hasTaetigkeitsschluessel = false;
                    if (_.get(taetigkeitsschluessel[0], 'wert') === '0') {
                        _.set(vm.partner, 'taetigkeitsschluessel', taetigkeitsschluessel[0]);
                    } else {
                        if (_.get(vm.partner, 'taetigkeitsschluessel.wert') === '0' && _.get(vm.comparePartner, 'taetigkeitsschluessel.wert') !== '0') {
                            _.set(vm.partner, 'beruf', BasisAngebotService.getConstant('beruf.ohneBerufsangabe'));
                            _.set(vm.partner, 'arbeitgeberBerufFiktiv', false);
                        } else if (_.get(vm.partner, 'taetigkeitsschluessel.wert') === '50' && _.get(vm.partner, 'beruf.wert') !== BasisAngebotService.getConstant('beruf.beamter').wert) {
                            _.set(vm.partner, 'beruf', BasisAngebotService.getConstant('beruf.beamter'));
                            _.set(vm.partner, 'arbeitgeberBerufFiktiv', true);
                        }
                    }
                }
            }).catch(function (error) {
                vm.hasTaetigkeitsschluessel = false;
                _.set(vm.partner, 'taetigkeitsschluessel', _.find(BasisAngebotService.getConstant('taetigkeitsschluessel'), ['wert', '0']));
            });
        }

        function handleArbeitgeberBeruf() {
            var arbeitsverhaeltnis = _.get(vm.model, 'arbeitsverhaeltnis'),
                bevorzugterArbeitgeber = _.get(vm.model, 'bevorzugterArbeitgeber'),
                bevorzugterBerufszweig = _.get(vm.model, 'bevorzugterBerufszweig'),
                ingenieur = _.get(vm.model, 'ingenieur');

            if (!arbeitsverhaeltnis) {
                return;
            }

            if (arbeitsverhaeltnis === 'oeffentlicher_dienst') {
                _.set(vm.partner, 'arbeitgeber', BasisAngebotService.getConstant('arbeitgeber.oeffentlicherDienst'));

                if (_.get(vm.partner, 'taetigkeitsschluessel.wert') === '50' && _.get(vm.partner, 'beruf.wert') !== BasisAngebotService.getConstant('beruf.beamter').wert) {
                    _.set(vm.partner, 'beruf', BasisAngebotService.getConstant('beruf.beamter'));
                    _.set(vm.partner, 'arbeitgeberBerufFiktiv', true);
                } else {
                    _.set(vm.partner, 'beruf', BasisAngebotService.getConstant('beruf.ohneBerufsangabe'));
                    _.set(vm.partner, 'arbeitgeberBerufFiktiv', true);
                }
            } else if (arbeitsverhaeltnis === 'angestellt') {
                if (bevorzugterArbeitgeber === false) {
                    _.set(vm.partner, 'arbeitgeber', BasisAngebotService.getConstant('arbeitgeber.sonstigerArbeitgeber'));
                    if (ingenieur === true) {
                        _.set(vm.partner, 'beruf', BasisAngebotService.getConstant('beruf.ingenieur'));
                    } else {
                        _.set(vm.partner, 'beruf', BasisAngebotService.getConstant('beruf.ohneBerufsangabe'));
                    }
                    _.set(vm.partner, 'arbeitgeberBerufFiktiv', true);
                } else if (bevorzugterArbeitgeber === true) {
                    _.set(vm.partner, 'beruf', BasisAngebotService.getConstant('beruf.ohneBerufsangabe'));
                    _.set(vm.partner, 'arbeitgeberBerufFiktiv', true);
                }
            } else if (arbeitsverhaeltnis === 'selbststaendig') {
                if (bevorzugterBerufszweig === false) {
                    _.set(vm.partner, 'arbeitgeber', BasisAngebotService.getConstant('arbeitgeber.selbststaendig'));
                    if (ingenieur === true) {
                        _.set(vm.partner, 'beruf', BasisAngebotService.getConstant('beruf.ingenieur'));
                    } else {
                        _.set(vm.partner, 'beruf', BasisAngebotService.getConstant('beruf.ohneBerufsangabe'));
                    }
                    _.set(vm.partner, 'arbeitgeberBerufFiktiv', true);
                } else if (bevorzugterBerufszweig === true) {
                    _.set(vm.partner, 'beruf', BasisAngebotService.getConstant('beruf.selbststaendig'));
                    _.set(vm.partner, 'arbeitgeberBerufFiktiv', false);
                }
            } else if (arbeitsverhaeltnis === 'ohne') {
                _.set(vm.partner, 'arbeitgeber', BasisAngebotService.getConstant('arbeitgeber.keinArbeitgeber'));
                _.set(vm.partner, 'beruf', BasisAngebotService.getConstant('beruf.ohneBerufsangabe'));
                _.set(vm.partner, 'arbeitgeberBerufFiktiv', false);
            }

            getTaetigkeitsschluessel();
        }

        function isArbeitgeberBerufErlaubt() {
            return (
                vm.disabled || (
                    vm.isPrivatPerson &&
                    !vm.isAnonym &&
                    _.get(vm.partner, 'arbeitgeberBerufFiktiv') === false &&
                    MiscUtilsService.isNotEmpty(_.get(vm.partner, 'arbeitgeber')) &&
                    MiscUtilsService.isNotEmpty(_.get(vm.partner, 'beruf')) &&
                    MiscUtilsService.isNotEmpty(_.get(vm.comparePartner, 'beruf')) &&
                    MiscUtilsService.isNotEmpty(_.get(vm.comparePartner, 'arbeitgeber')) &&
                    _.get(vm.model, 'arbeitsverhaeltnisAnpassen') !== true
                )
            );
        }

        function onArbeitsverhaeltnisAnpassen() {
            _.set(vm.model, 'arbeitsverhaeltnisAnpassen', true);

            _.set(vm.model, 'arbeitsverhaeltnis', null);
            _.set(vm.model, 'bevorzugterArbeitgeber', null);
            _.set(vm.model, 'bevorzugterBerufszweig', null);
            _.set(vm.model, 'ingenieur', null);
            _.set(vm.model, 'blaulichtVorhanden', null);
            _.set(vm.partner, 'arbeitgeber', null);
            _.set(vm.partner, 'beruf', null);
            _.set(vm.partner, 'taetigkeitsschluessel', null);
            _.set(vm.partner, 'blaulicht', null);
        }

        function isLinkArbeitsverhaeltnisAnpassenErlaubt() {
            return !vm.disabled;
        }
        function onArbeitsverhaeltnisChanged(arbeitsverhaeltnis) {
            _.set(vm.model, 'bevorzugterArbeitgeber', null);
            _.set(vm.model, 'bevorzugterBerufszweig', null);
            _.set(vm.model, 'ingenieur', null);
            _.set(vm.partner, 'arbeitgeber', null);
            _.set(vm.partner, 'beruf', null);
            _.set(vm.partner, 'taetigkeitsschluessel', null);

            handleArbeitgeberBeruf();

            if (!isBlaulichtErlaubt()) {
                _.set(vm.partner, 'blaulicht', null);
                _.set(vm.model, 'blaulichtVorhanden', null);
            }
        }
        function onTaetigkeitsschluesselChanged(taetigkeitsschluessel) {
            handleArbeitgeberBeruf(null, taetigkeitsschluessel);
        }

        function onBevorzugterArbeitgeberChanged(bevorzugterArbeitgeber) {
            _.set(vm.partner, 'arbeitgeber', null);
            _.set(vm.model, 'ingenieur', null);
            handleArbeitgeberBeruf();
        }

        function onBevorzugterBerufszweigChanged(bevorzugterBerufszweig) {
            _.set(vm.partner, 'arbeitgeber', null);
            _.set(vm.model, 'ingenieur', null);
            handleArbeitgeberBeruf();
        }

        function onIngenieurChanged() {
            handleArbeitgeberBeruf();
        }
        function onBlaulichtVorhandenChanged(blaulichtVorhanden) {
            var blaulicht = SchluesselWerteUtilsService.create('BLAULICHT', '5', 'Einheitliches Blaulicht');

            if (blaulichtVorhanden === true) {
                _.set(vm.partner, 'blaulicht', blaulicht);
            } else {
                _.set(vm.partner, 'blaulicht', null);
            }
        }

        function isBevorzugterArbeitgeberErlaubt() {
            return (
                vm.isPrivatPerson &&
                _.get(vm.model, 'arbeitsverhaeltnis') === 'angestellt'
            );
        }

        function isAngestellterBevorzugteArbeitgeberErlaubt() {
            return (
                isBevorzugterArbeitgeberErlaubt() &&
                _.get(vm.model, 'bevorzugterArbeitgeber') === true
            );
        }

        function getAngestellterBevorzugteArbeitgeber() {
            return _.filter(vm.CONSTANTS.listen.arbeitgeber, function (arbeitgeber) {
                return _.includes(AppConfig.ANGEBOT.angestellterBevorzugteArbeitgeber, arbeitgeber.wert);
            });
        }

        function isBevorzugterBerufszweigErlaubt() {
            return (
                vm.isPrivatPerson &&
                _.get(vm.model, 'arbeitsverhaeltnis') === 'selbststaendig'
            );
        }

        function isSelbststaendigerBevorzugteBerufszweigeErlaubt() {
            return (
                isBevorzugterBerufszweigErlaubt() &&
                _.get(vm.model, 'bevorzugterBerufszweig') === true
            );
        }

        function getSelbststaendigerBevorzugteBerufszweige() {
            return _.filter(vm.CONSTANTS.listen.arbeitgeber, function (arbeitgeber) {
                return _.includes(AppConfig.ANGEBOT.selbststaendigerBevorzugteBerufszweige, arbeitgeber.wert);
            });
        }

        function isIngenieurErlaubt() {
            return (
                vm.isPrivatPerson &&
                (
                    _.get(vm.model, 'arbeitsverhaeltnis') === 'angestellt' &&
                    _.get(vm.model, 'bevorzugterArbeitgeber') === false
                ) || (
                    _.get(vm.model, 'arbeitsverhaeltnis') === 'selbststaendig' &&
                    _.get(vm.model, 'bevorzugterBerufszweig') === false
                )
            );
        }

        function isBlaulichtErlaubt() {
            return (
                _.size(vm.sw.blaulicht) > 0 &&
                AppConfig.ANGEBOT.blaulichtVorhanden &&
                vm.isPrivatPerson
            );
        }
    }

    BlockArbeitgeberBerufService.$inject =[
        'lodash',
        'AppConfig',
        'BasisAngebotService',
        'MiscUtilsService'
    ];

    function BlockArbeitgeberBerufService(_, AppConfig, BasisAngebotService, MiscUtilsService) {
        var that = this;

        that.getGuiFlags = getGuiFlags;

        function getGuiFlags(partner, comparePartner) {
            var guiFlags = {};

            if (comparePartner) {
                if (
                    _.get(partner, 'arbeitgeber.wert') !== _.get(comparePartner, 'arbeitgeber.wert') ||
                    _.get(partner, 'beruf.wert') !== _.get(comparePartner, 'beruf.wert') ||
                    MiscUtilsService.isEmpty(_.get(comparePartner, 'arbeitgeber')) ||
                    MiscUtilsService.isEmpty(_.get(comparePartner, 'beruf'))
                ) {
                    _.set(guiFlags, 'arbeitsverhaeltnisAnpassen', true);
                }
            }

            if (_.get(partner, 'arbeitgeber.wert') === BasisAngebotService.getConstant('arbeitgeber.oeffentlicherDienst').wert) {
                _.set(guiFlags, 'arbeitsverhaeltnis', 'oeffentlicher_dienst');

            } else if (
                _.includes(AppConfig.ANGEBOT.angestellterBevorzugteArbeitgeber, _.get(partner, 'arbeitgeber.wert')) &&
                _.get(partner, 'beruf.wert') !== BasisAngebotService.getConstant('beruf.selbststaendig.wert')
            ) {
                _.set(guiFlags, 'arbeitsverhaeltnis', 'angestellt');
                _.set(guiFlags, 'bevorzugterArbeitgeber', true);
                _.set(guiFlags, 'bevorzugterBerufszweig', null);
                _.set(guiFlags, 'ingenieur', null);

            } else if (
                _.includes(AppConfig.ANGEBOT.selbststaendigerBevorzugteBerufszweige, _.get(partner, 'arbeitgeber.wert')) &&
                _.get(partner, 'beruf.wert') === BasisAngebotService.getConstant('beruf.selbststaendig.wert')
            ) {
                _.set(guiFlags, 'arbeitsverhaeltnis', 'selbststaendig');
                _.set(guiFlags, 'bevorzugterBerufszweig', true);
                _.set(guiFlags, 'bevorzugterArbeitgeber', null);
                _.set(guiFlags, 'ingenieur', null);

            } else if (_.get(partner, 'arbeitgeber.wert') === BasisAngebotService.getConstant('arbeitgeber.keinArbeitgeber').wert) {
                _.set(guiFlags, 'arbeitsverhaeltnis', 'ohne');

            } else if (_.get(partner, 'arbeitgeber.wert') === BasisAngebotService.getConstant('arbeitgeber.sonstigerArbeitgeber').wert) {
                _.set(guiFlags, 'arbeitsverhaeltnis', 'angestellt');
                _.set(guiFlags, 'bevorzugterArbeitgeber', false);
                _.set(guiFlags, 'bevorzugterBerufszweig', null);

                if (_.get(partner, 'beruf.wert') === BasisAngebotService.getConstant('beruf.ingenieur').wert) {
                    _.set(guiFlags, 'ingenieur', true);
                }

            } else if (_.get(partner, 'arbeitgeber.wert') === BasisAngebotService.getConstant('arbeitgeber.selbststaendig').wert) {
                _.set(guiFlags, 'arbeitsverhaeltnis', 'selbststaendig');
                _.set(guiFlags, 'bevorzugterArbeitgeber', null);
                _.set(guiFlags, 'bevorzugterBerufszweig', false);

                if (_.get(partner, 'beruf.wert') === BasisAngebotService.getConstant('beruf.ingenieur').wert) {
                    _.set(guiFlags, 'ingenieur', true);
                }
            }

            return guiFlags;
        }
    }
})();
